import React from 'react';

import styled from 'styled-components';

import GroupsControls from './GroupsControls';
import GroupsTable from './table/GroupsTable';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 10px 30px;

  &.simple {
    width: 100%;
    padding: 0;
  }
`;

const GroupsData = () => {
  return (
    <Container>
      <GroupsControls />
      <GroupsTable />
    </Container>
  );
};

export default GroupsData;
